
// function getLogoId() {

//     $('.js-open-modal').on('click', function(){
//         var logo_id = $(this).data('logo-id');
//         console.log($(this).data('logo-id'));
//     });
// }

(function($) {

    $.fn.getLogoId = function() {
        var that = this;

        $(that).on('click', function() {
            var $that = $(this);
            var logo_id = $that.data('logo-id');
            // console.log($that.data('logo-id'));
            $('#js-alert-iron').data('logo-id', logo_id);
        });

        return this;
    }

}(jQuery));


function deleteLogo() {

    $('.js-logo-delete').on('click', function(){
        var logo_id = $("#js-alert-iron").data('logo-id');
        console.log(logo_id);
        $.ajax({
            type: "DELETE",
            url: "/api/logos/" + logo_id + "/",
            headers: {
                'X-CSRFToken': csrftoken
            },
            success: function(res){
                console.log(res);
                location.reload();
            },
            error: function(err){
                console.log(err);
            }
        });
    });
}


$(function(){

    if ($('#logo-list-account').length) {
        // getLogoId();
        $(".js-open-modal").getLogoId();
        deleteLogo();
    }

});
